const actions = {
  CIRCUITS_ERROR: "CIRCUITS_ERROR",
  GET_CIRCUITS_REQUEST: "GET_CIRCUITS_REQUEST",
  GET_CIRCUITS_SUCCESS: "GET_CIRCUITS_SUCCESS",
  GET_CIRCUIT_REQUEST: "GET_CIRCUIT_REQUEST",
  GET_CIRCUIT_SUCCESS: "GET_CIRCUIT_SUCCESS",
  DELETE_CIRCUIT_REQUEST: "DELETE_CIRCUIT_REQUEST",
  DELETE_CIRCUIT_SUCCESS: "DELETE_CIRCUIT_SUCCESS",
  UPDATE_CIRCUIT_REQUEST: "UPDATE_CIRCUIT_REQUEST",
  UPDATE_CIRCUIT_SUCCESS: "UPDATE_CIRCUIT_SUCCESS",
  CREATE_CIRCUIT_REQUEST: "CREATE_CIRCUIT_REQUEST",
  CREATE_CIRCUIT_SUCCESS: "CREATE_CIRCUIT_SUCCESS",
  GET_CIRCUIT_CATEGORIES_REQUEST: "GET_CIRCUIT_CATEGORIES_REQUEST",
  GET_CIRCUIT_CATEGORIES_SUCCESS: "GET_CIRCUIT_CATEGORIES_SUCCESS",
  UPDATE_CIRCUIT_DEMAND_CONFIG_REQUEST: "UPDATE_CIRCUIT_DEMAND_CONFIG_REQUEST",
  UPDATE_CIRCUIT_DEMAND_CONFIG_SUCCESS: "UPDATE_CIRCUIT_DEMAND_CONFIG_SUCCESS",

  getCircuits: (token, siteId, zoneId) => {
    return {
      type: actions.GET_CIRCUITS_REQUEST,
      token,
      siteId,
      zoneId
    };
  },
  getCircuitById: (token, id, siteId, zoneId) => {
    return {
      type: actions.GET_CIRCUIT_REQUEST,
      token,
      id,
      siteId,
      zoneId
    };
  },
  deleteCircuit: (token, id, siteId, zoneId) => {
    return {
      type: actions.DELETE_CIRCUIT_REQUEST,
      token,
      id,
      siteId,
      zoneId
    };
  },
  updateCircuit: (token, circuit, siteId, zoneId) => {
    return {
      type: actions.UPDATE_CIRCUIT_REQUEST,
      token,
      circuit,
      siteId,
      zoneId
    };
  },
  createCircuit: (token, circuit, siteId, zoneId) => {
    return {
      type: actions.CREATE_CIRCUIT_REQUEST,
      token,
      circuit,
      siteId,
      zoneId
    };
  },
  getCircuitCategories: () => {
    return {
      type: actions.GET_CIRCUIT_CATEGORIES_REQUEST
    };
  },
  updateCircuitDemandConfig: (token, siteId, zoneId, circuitId, demandSwitch, demandType, interval) => {
    return {
      token,
      type: actions.UPDATE_CIRCUIT_DEMAND_CONFIG_REQUEST,
      siteId,
      zoneId,
      circuitId,
      demandSwitch,
      demandType,
      interval
    };
  }
};

const circuitsActions = actions;

export default circuitsActions;
